module.exports = require('./Hero');